import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roof-cleaning-delmar-ny")({
  beforeLoad: () => {
    throw redirect({ to: "/roof-washing-delmar-ny", statusCode: 301 });
  },
});
